<template>
    <v-container>
        <v-layout row="" wrap="">

            <v-flex pa-2 v-show="ucus1" xs12 sm12 md12>
                <v-layout justify-space-between column>
                    <v-card>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md2>
                                <v-img src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" height="100%"
                                    width="100%">
                                    <v-container fluid>
                                        <v-layout align-center="">
                                            <v-flex xs12 align-content-center="">
                                                <v-container fluid="">
                                                    <span style="text-shadow: 3px 2px 1px #000;"
                                                        class="display-1 font-weight-medium white--text ">1. {{ $t('Flight') }} </span>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-img>
                            </v-flex>
                            <v-flex xs12 sm12 md10>
                                <v-card-actions>
                                    <v-layout row="" wrap>
                                        <v-flex xs12 sm12 md2>
                                            <tarihcomp :etiket="$t('Flight-Date')" v-bind:value="val.Ucus1.UcusTarihi"
                                                v-model="val.Ucus1.UcusTarihi"></tarihcomp>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" maxlength="5" v-model="val.Ucus1.UcusSaat"
                                                :label="$t('Flight-Time')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus1.UcusHY" :label="$t('Airline')">
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus1.UcusNo" :label="$t('Flight-No')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus1.Parkur" :label="$t('Departure-TWO')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus2.Parkur" :label="$t('Arrival')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus1.UcusClass" :label="$t('Class')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus1.UcusClassTip"
                                                :label="$t('Class-Type')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <tarihcomp :etiket="$t('Arrival-Date')" v-bind:value="val.Ucus1.VarisTarihi"
                                                v-model="val.Ucus1.VarisTarihi"></tarihcomp>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus1.VarisSaat"
                                                :label="$t('Arrival-Time')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('FareBases')"
                                                v-model="val.Ucus1.FareBases"></parainput>
                                        </v-flex>
                                        
                                        <v-flex xs12 sm2 md2>
                                            <v-checkbox :label="$t('Transfer-v2')" v-model="val.Ucus1.Aktarma" hide-details="">
                                            </v-checkbox>
                                            <!-- EX ALANLAR (1. Uçuş) -->

                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
  <v-text-field hide-details
    v-model="val.Ucus1.ExAciklamaUcus.KabinBagaj"
    :label="$t('Cabin-Baggage')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm2 md2>
  <v-text-field hide-details
    v-model="val.Ucus1.ExAciklamaUcus.Bagaj"
    :label="$t('Baggage')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm2 md2>
  <v-select hide-details
    :items="yemekDurumuItems"
    item-text="text"
    item-value="value"
    v-model="val.Ucus1.ExAciklamaUcus.YemekDurumu"
    :label="$t('Meal-Status')">
  </v-select>
</v-flex>

<v-flex xs12 sm4 md4>
  <v-text-field hide-details
    v-model="val.Ucus1.ExAciklamaUcus.YemekAciklama"
    :label="$t('Meal-Description')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm6 md6>
  <v-textarea auto-grow rows="1" hide-details
    v-model="val.Ucus1.ExAciklamaUcus.IptalSartlari"
    :label="$t('Cancellation-Terms')">
  </v-textarea>
</v-flex>

<v-flex xs12 sm6 md6>
  <v-textarea auto-grow rows="1" hide-details
    v-model="val.Ucus1.ExAciklamaUcus.IadeSartlari"
    :label="$t('Refund-Terms')">
  </v-textarea>
</v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-layout>
            </v-flex>

            <v-flex pa-2 v-show="ucus2" xs12 sm12 md12>
                <v-layout justify-space-between column>
                    <v-card>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md2>
                                <v-img src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" height="100%"
                                    width="100%">
                                    <v-container fluid>
                                        <v-layout align-center="">
                                            <v-flex xs12 align-content-center="">
                                                <v-container fluid="">
                                                    <span style="text-shadow: 3px 2px 1px #000;"
                                                        class="display-1 font-weight-medium white--text ">2. {{ $t('Flight') }} </span>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-img>
                            </v-flex>

                            <v-flex xs12 sm12 md10>
                                <v-card-actions>
                                    <v-layout row="" wrap>
                                        <v-flex xs12 sm12 md2>
                                            <tarihcomp :etiket="$t('Flight-Date')" v-bind:value="val.Ucus2.UcusTarihi"
                                                v-model="val.Ucus2.UcusTarihi"></tarihcomp>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus2.UcusSaat"
                                                :label="$t('Flight-Time')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus2.UcusHY"
                                                :label="$t('Airline-Code')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus2.UcusNo" :label="$t('Flight-No')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus2.Parkur" :label="$t('Departure-TWO')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus3.Parkur" :label="$t('Arrival')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus2.UcusClass" :label="$t('Class')">
                                            </v-text-field>
                                        </v-flex>
                                         <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus2.UcusClassTip"
                                                :label="$t('Class-Type')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <tarihcomp :etiket="$t('Arrival-Date')" v-bind:value="val.Ucus2.VarisTarihi"
                                                v-model="val.Ucus2.VarisTarihi"></tarihcomp>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus2.VarisSaat"
                                                :label="$t('Arrival-Time')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('FareBases')"
                                                v-model="val.Ucus2.FareBases"></parainput>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-checkbox :label="$t('Transfer-v2')" v-model="val.Ucus2.Aktarma" hide-details="">
                                            </v-checkbox>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
  <v-text-field hide-details
    v-model="val.Ucus2.ExAciklamaUcus.KabinBagaj"
    :label="$t('Cabin-Baggage')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm2 md2>
  <v-text-field hide-details
    v-model="val.Ucus2.ExAciklamaUcus.Bagaj"
    :label="$t('Baggage')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm2 md2>
  <v-select hide-details
    :items="yemekDurumuItems"
    item-text="text"
    item-value="value"
    v-model="val.Ucus2.ExAciklamaUcus.YemekDurumu"
    :label="$t('Meal-Status')">
  </v-select>
</v-flex>

<v-flex xs12 sm4 md4>
  <v-text-field hide-details
    v-model="val.Ucus2.ExAciklamaUcus.YemekAciklama"
    :label="$t('Meal-Description')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm6 md6>
  <v-textarea auto-grow rows="1" hide-details
    v-model="val.Ucus2.ExAciklamaUcus.IptalSartlari"
    :label="$t('Cancellation-Terms')">
  </v-textarea>
</v-flex>

<v-flex xs12 sm6 md6>
  <v-textarea auto-grow rows="1" hide-details
    v-model="val.Ucus2.ExAciklamaUcus.IadeSartlari"
    :label="$t('Refund-Terms')">
  </v-textarea>
</v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-layout>
            </v-flex>

            <v-flex pa-2 v-show="ucus3" xs12 sm12 md12>
                <v-layout justify-space-between column>
                    <v-card>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md2>
                                <v-img src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" height="100%"
                                    width="100%">
                                    <v-container fluid>
                                        <v-layout align-center="">
                                            <v-flex xs12 align-content-center="">
                                                <v-container fluid="">
                                                    <span style="text-shadow: 3px 2px 1px #000;"
                                                        class="display-1 font-weight-medium white--text ">3. {{$t('Flight')}} </span>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-img>
                            </v-flex>

                            <v-flex xs12 sm12 md10>
                                <v-card-actions>
                                    <v-layout row="" wrap>
                                        <v-flex xs12 sm12 md2>
                                            <tarihcomp :etiket="$t('Flight-Date')" v-bind:value="val.Ucus3.UcusTarihi"
                                                v-model="val.Ucus3.UcusTarihi"></tarihcomp>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus3.UcusSaat"
                                                :label="$t('Flight-Time')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus3.UcusHY"
                                                :label="$t('Airline-Code')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus3.UcusNo" :label="$t('Flight-No')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus3.Parkur" :label="$t('Departure-TWO')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus4.Parkur" :label="$t('Arrival')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus3.UcusClass" :label="$t('Class')">
                                            </v-text-field>
                                        </v-flex>
                                         <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus3.UcusClassTip"
                                                :label="$t('Class-Type')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <tarihcomp :etiket="$t('Arrival-Date')" v-bind:value="val.Ucus3.VarisTarihi"
                                                v-model="val.Ucus3.VarisTarihi"></tarihcomp>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus3.VarisSaat"
                                                :label="$t('Arrival-Time')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('FareBases')"
                                                v-model="val.Ucus3.FareBases"></parainput>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-checkbox :label="$t('Transfer-v2')" v-model="val.Ucus3.Aktarma" hide-details="">
                                            </v-checkbox>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
  <v-text-field hide-details
    v-model="val.Ucus3.ExAciklamaUcus.KabinBagaj"
    :label="$t('Cabin-Baggage')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm2 md2>
  <v-text-field hide-details
    v-model="val.Ucus3.ExAciklamaUcus.Bagaj"
    :label="$t('Baggage')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm2 md2>
  <v-select hide-details
    :items="yemekDurumuItems"
    item-text="text"
    item-value="value"
    v-model="val.Ucus3.ExAciklamaUcus.YemekDurumu"
    :label="$t('Meal-Status')">
  </v-select>
</v-flex>

<v-flex xs12 sm4 md4>
  <v-text-field hide-details
    v-model="val.Ucus3.ExAciklamaUcus.YemekAciklama"
    :label="$t('Meal-Description')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm6 md6>
  <v-textarea auto-grow rows="1" hide-details
    v-model="val.Ucus3.ExAciklamaUcus.IptalSartlari"
    :label="$t('Cancellation-Terms')">
  </v-textarea>
</v-flex>

<v-flex xs12 sm6 md6>
  <v-textarea auto-grow rows="1" hide-details
    v-model="val.Ucus3.ExAciklamaUcus.IadeSartlari"
    :label="$t('Refund-Terms')">
  </v-textarea>
</v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-layout>
            </v-flex>

            <v-flex pa-2 v-show="ucus4" xs12 sm12 md12>
                <v-layout justify-space-between column>
                    <v-card>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md2>
                                <v-img src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" height="100%"
                                    width="100%">
                                    <v-container fluid>
                                        <v-layout align-center="">
                                            <v-flex xs12 align-content-center="">
                                                <v-container fluid="">
                                                    <span style="text-shadow: 3px 2px 1px #000;"
                                                        class="display-1 font-weight-medium white--text ">4. {{ $t('Flight') }}</span>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-img>
                            </v-flex>

                            <v-flex xs12 sm12 md10>
                                <v-card-actions>
                                    <v-layout row="" wrap>
                                        <v-flex xs12 sm12 md2>
                                            <tarihcomp :etiket="$t('Flight-Date')" v-bind:value="val.Ucus4.UcusTarihi"
                                                v-model="val.Ucus4.UcusTarihi"></tarihcomp>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus4.UcusSaat"
                                                :label="$t('Flight-Time')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus4.UcusHY"
                                                :label="$t('Airline-Code')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus4.UcusNo" :label="$t('Flight-No')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus4.Parkur" :label="$t('Departure-TWO')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus5.Parkur" :label="$t('Arrival')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus4.UcusClass" :label="$t('Class')">
                                            </v-text-field>
                                        </v-flex>
                                         <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus4.UcusClassTip"
                                                :label="$t('Class-Type')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <tarihcomp :etiket="$t('Arrival-Date')" v-bind:value="val.Ucus4.VarisTarihi"
                                                v-model="val.Ucus4.VarisTarihi"></tarihcomp>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus4.VarisSaat"
                                                :label="$t('Arrival-Time')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('FareBases')"
                                                v-model="val.Ucus4.FareBases"></parainput>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-checkbox :label="$t('Transfer-v2')" v-model="val.Ucus4.Aktarma" hide-details="">
                                            </v-checkbox>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
  <v-text-field hide-details
    v-model="val.Ucus4.ExAciklamaUcus.KabinBagaj"
    :label="$t('Cabin-Baggage')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm2 md2>
  <v-text-field hide-details
    v-model="val.Ucus4.ExAciklamaUcus.Bagaj"
    :label="$t('Baggage')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm2 md2>
  <v-select hide-details
    :items="yemekDurumuItems"
    item-text="text"
    item-value="value"
    v-model="val.Ucus4.ExAciklamaUcus.YemekDurumu"
    :label="$t('Meal-Status')">
  </v-select>
</v-flex>

<v-flex xs12 sm4 md4>
  <v-text-field hide-details
    v-model="val.Ucus4.ExAciklamaUcus.YemekAciklama"
    :label="$t('Meal-Description')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm6 md6>
  <v-textarea auto-grow rows="1" hide-details
    v-model="val.Ucus4.ExAciklamaUcus.IptalSartlari"
    :label="$t('Cancellation-Terms')">
  </v-textarea>
</v-flex>

<v-flex xs12 sm6 md6>
  <v-textarea auto-grow rows="1" hide-details
    v-model="val.Ucus4.ExAciklamaUcus.IadeSartlari"
    :label="$t('Refund-Terms')">
  </v-textarea>
</v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-layout>
            </v-flex>

            <v-flex pa-2 v-show="ucus5" xs12 sm12 md12>
                <v-layout justify-space-between column>
                    <v-card>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md2>
                                <v-img src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" height="100%"
                                    width="100%">
                                    <v-container fluid>
                                        <v-layout align-center="">
                                            <v-flex xs12 align-content-center="">
                                                <v-container fluid="">
                                                    <span style="text-shadow: 3px 2px 1px #000;"
                                                        class="display-1 font-weight-medium white--text ">5. {{ $t('Flight') }}</span>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-img>
                            </v-flex>

                            <v-flex xs12 sm12 md10>
                                <v-card-actions>
                                    <v-layout row="" wrap>
                                        <v-flex xs12 sm12 md2>
                                            <tarihcomp :etiket="$t('Flight-Date')" v-bind:value="val.Ucus5.UcusTarihi"
                                                v-model="val.Ucus5.UcusTarihi"></tarihcomp>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus5.UcusSaat"
                                                :label="$t('Flight-Time')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus5.UcusHY"  :label="$t('Airline-Code')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus5.UcusNo" :label="$t('Flight-No')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus5.Parkur" :label="$t('Airport')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus5.UcusClass" :label="$t('Class')">
                                            </v-text-field>
                                        </v-flex>
                                         <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus5.UcusClassTip"
                                                :label="$t('Class-Type')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <tarihcomp :etiket="$t('Arrival-Date')" v-bind:value="val.Ucus5.VarisTarihi"
                                                v-model="val.Ucus5.VarisTarihi"></tarihcomp>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-text-field hide-details="" v-model="val.Ucus5.VarisSaat"
                                                :label="$t('Arrival-Time')">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('FareBases')"
                                                v-model="val.Ucus5.FareBases"></parainput>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
                                            <v-checkbox :label="$t('Transfer-v2')"  v-model="val.Ucus5.Aktarma" hide-details="">
                                            </v-checkbox>
                                        </v-flex>
                                        <v-flex xs12 sm2 md2>
  <v-text-field hide-details
    v-model="val.Ucus5.ExAciklamaUcus.KabinBagaj"
    :label="$t('Cabin-Baggage')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm2 md2>
  <v-text-field hide-details
    v-model="val.Ucus5.ExAciklamaUcus.Bagaj"
    :label="$t('Baggage')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm2 md2>
  <v-select hide-details
    :items="yemekDurumuItems"
    item-text="text"
    item-value="value"
    v-model="val.Ucus5.ExAciklamaUcus.YemekDurumu"
    :label="$t('Meal-Status')">
  </v-select>
</v-flex>

<v-flex xs12 sm4 md4>
  <v-text-field hide-details
    v-model="val.Ucus5.ExAciklamaUcus.YemekAciklama"
    :label="$t('Meal-Description')">
  </v-text-field>
</v-flex>

<v-flex xs12 sm6 md6>
  <v-textarea auto-grow rows="1" hide-details
    v-model="val.Ucus5.ExAciklamaUcus.IptalSartlari"
    :label="$t('Cancellation-Terms')">
  </v-textarea>
</v-flex>

<v-flex xs12 sm6 md6>
  <v-textarea auto-grow rows="1" hide-details
    v-model="val.Ucus5.ExAciklamaUcus.IadeSartlari"
    :label="$t('Refund-Terms')">
  </v-textarea>
</v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import tarihcomp from '../../customcomp/tarihim'
    import parainput from '@/components/app/customcomp/parainput.vue'
    import helpers from "@/components/app/customcomp/helpers.js"

    export default {
        props: ["value", "ucus1", "ucus2", "ucus3", "ucus4", "ucus5", ],
        components: {
            tarihcomp,
            parainput

        },
        computed: {
            val: {
                get: function () {
                    return this.value;
                },
                set: function (newValue) {
                    this.$emit('input', newValue)
                },
            },
        },
mounted() {
  this.ensureExModels()
},

        data() {
            return {
yemekDurumuItems: [
      { text: this.$t('No-v2'), value: 0 },
      { text: this.$t('Yes'), value: 1 },
    ],
            }
        },

        watch: {
value: {
    deep: true,
    handler() {
      this.ensureExModels()
    }
  }
        },
        methods: {
            getparabirimi() {
                return helpers.getparabirimi()
            },
            ensureExModels() {
    const ensure = (u) => {
      if (!u) return
      if (!u.ExAciklamaUcus) {
       
        this.$set(u, 'ExAciklamaUcus', {
          UcusIndex: u.ParkurNo || null,   
          KabinBagaj: '',
          Bagaj: '',
          YemekDurumu: null, 
          YemekAciklama: '',
          IptalSartlari: '',
          IadeSartlari: '',
        })
      }
    }

    ensure(this.val && this.val.Ucus1)
    ensure(this.val && this.val.Ucus2)
    ensure(this.val && this.val.Ucus3)
    ensure(this.val && this.val.Ucus4)
    ensure(this.val && this.val.Ucus5)
  },


        },


    }
</script>